/**
 *
 * @author: Huning
 * @date: 2019-07-05
 *
 */
import React, { PureComponent, Fragment } from 'react'
import PropTypes from 'prop-types'
import { Icon, Tooltip, Button } from 'antd'

import style from './index.less'

class FilterButton extends PureComponent {
  static propTypes = {
    open: PropTypes.bool,
    onClick: PropTypes.func
  }

  static defaultProps = {
    open: false,
    onClick: () => {}
  }

  componentDidMount() {
    window.addEventListener('click', this.bindWindowClose)
  }

  componentWillUnmount() {
    window.removeEventListener('click', this.bindWindowClose)
  }

  bindWindowClose = () => {
    if (this.props.open) {
      this.props.onClick()
    }
  }

  onClick = e => {
    const { nativeEvent } = e
    if (window.event) {
      window.event.cancelBubble = true
    } else {
      nativeEvent.stopPropagation()
    }
    this.props.onClick()
  }

  render() {
    const { props } = this
    const { open, onClick } = props

    return (
      <Button
        type={open ? 'default' : 'link'}
        size="small"
        onClick={this.onClick}
      >
        {open ? '隐藏' : '搜索更多'}
      </Button>
    )
  }
}

export default FilterButton
